import { memo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Layout, SupportIcon } from "lola-framework-ui-test";
import { AuraLayout } from "../components/AuraLayout";
import { SupportSheet } from "../components/SupportSheet";
import { useStore } from "../store/globalState";
import { TITLE_COLOR } from "../constants";
import { Navbar } from "../components/Navbar";

/**
 * Standalone `/support` entry, kept for deep links and session resume. Screens
 * that own a "need help" affordance open the sheet in place instead; here it is
 * opened on arrival so both paths look the same.
 */
export const SupportPage = memo(() => {
  const { t } = useTranslation();
  const { theme } = useStore();
  const colorConfig = theme.whiteView;
  const { dropzoneColors } = colorConfig;
  const navigate = useNavigate();

  return (
    <>
      <AuraLayout colorConfig={colorConfig} className="need-help-header">
        <Layout.Header>
          <Navbar
            onBackClick={() => navigate(-1)}
            title={t("common.needHelp")}
            align="right"
            color={TITLE_COLOR}
            icon={<SupportIcon size={35} colors={dropzoneColors} />}
          />
        </Layout.Header>
        <Layout.Content>
          <section className="support-page-v2-container" />
        </Layout.Content>
      </AuraLayout>
      <SupportSheet visible onClose={() => navigate(-1)} />
    </>
  );
});
